import { useCallback, useEffect, useRef, useState } from "react";
import Api from "../services/api";
export function useResource(url, events = ["orders-changed"]) {
  const [state, setState] = useState({
    url,
    data: null,
    error: "",
    loading: Boolean(url),
  });
  const generation = useRef(0);
  const refresh = useCallback(async () => {
    const current = ++generation.current;
    if (!url) {
      setState({ url, data: null, error: "", loading: false });
      return;
    }
    setState((previous) =>
      previous.url === url
        ? { ...previous, loading: true }
        : { url, data: null, error: "", loading: true },
    );
    try {
      const result = await Api.request(url);
      if (current === generation.current)
        setState({ url, data: result, error: "", loading: false });
    } catch (failure) {
      if (current === generation.current)
        setState({ url, data: null, error: failure.message, loading: false });
    }
  }, [url]);
  const eventKey = events.join("|");
  useEffect(() => {
    let alive = true,
      queued = false;
    refresh();
    const changed = () => {
      if (queued) return;
      queued = true;
      Promise.resolve().then(() => {
        queued = false;
        if (alive) refresh();
      });
    };
    const names = url ? eventKey.split("|").filter(Boolean) : [];
    names.forEach((name) => document.addEventListener(name, changed));
    const requests = generation;
    return () => {
      alive = false;
      requests.current++;
      names.forEach((name) => document.removeEventListener(name, changed));
    };
  }, [refresh, eventKey, url]);
  return {
    data: url && state.url === url ? state.data : null,
    error: url && state.url === url ? state.error : "",
    loading: Boolean(url) && (state.url !== url || state.loading),
    refresh,
  };
}
export function usePage(title, className) {
  useEffect(() => {
    document.title = "Zirve Döküm — " + title;
    document.body.className = className;
    return () => {
      document.body.className = "";
    };
  }, [title, className]);
}
